"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable no-case-declarations */
var ProviderModalOOI = exports["default"] = /*#__PURE__*/function (_Component) {
  function ProviderModalOOI(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var urlPath = props.urlPath,
      urlParams = props.urlParams;
    _this.state = {
      urlPath: urlPath,
      urlParams: urlParams
    };
    return _this;
  }
  (0, _inheritsLoose2["default"])(ProviderModalOOI, _Component);
  var _proto = ProviderModalOOI.prototype;
  _proto.handleMessageReceived = function handleMessageReceived(type, payload, resolve, reject, providerId) {
    var _this$props = this.props,
      styleId = _this$props.styleId,
      additionalParams = _this$props.additionalParams,
      artStoreApi = _this$props.artStoreApi,
      galleryId = _this$props.galleryId,
      onClose = _this$props.onClose,
      onUpdateCartItems = _this$props.onUpdateCartItems;
    var itemUrl = additionalParams.itemUrl,
      isDemo = additionalParams.isDemo;
    switch (type) {
      case _providerEvents["default"].close:
        onClose();
        break;
      case _providerEvents["default"].addToCart:
        var isDemoBoolean = isDemo === false.toString() || isDemo === true.toString();
        if (!galleryId || !itemUrl || !isDemoBoolean) {
          reject('Adding to cart is not supported in this context');
        } else {
          var uuid = payload.uuid,
            quantity = payload.quantity,
            metadata = payload.metadata;
          artStoreApi.addToCart({
            uuid: uuid,
            itemUrl: itemUrl,
            galleryId: galleryId,
            providerId: providerId,
            quantity: quantity,
            isDemo: isDemo === true.toString(),
            metadata: metadata,
            styleId: styleId
          });
          resolve();
        }
        break;
      case _providerEvents["default"].updateCartItem:
        artStoreApi.updateCartItem({
          uuid: payload.uuid,
          metadata: payload.metadata,
          quantity: payload.quantity
        });
        onUpdateCartItems();
        break;
      case _providerEvents["default"].clearCart:
        artStoreApi.clearCart();
        break;
      case _providerEvents["default"].removeFromCart:
        artStoreApi.removeFromCart({
          uuid: payload.uuid
        });
        break;
      case _providerEvents["default"].getCartItems:
        var items = this.props.cartItems || [];
        resolve(items);
        break;
      default:
        break;
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      name = _this$props2.name,
      connectedProviders = _this$props2.connectedProviders,
      wixSdk = _this$props2.wixSdk,
      additionalProviderParams = _this$props2.additionalProviderParams,
      consentPolicy = _this$props2.consentPolicy;
    var customAdditionalParams = {};
    consentPolicy && (customAdditionalParams.consentPolicy = consentPolicy);
    if (additionalProviderParams) {
      var srcId = additionalProviderParams.srcId,
        appDefId = additionalProviderParams.appDefId,
        isAlbumStore = additionalProviderParams.isAlbumStore;
      srcId && (customAdditionalParams.srcId = srcId);
      appDefId && (customAdditionalParams.appDefId = appDefId);
      isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
    }
    var renderComponent = connectedProviders ? /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], {
      api: new _WixSDKProviderApi["default"](wixSdk),
      connectedProviders: connectedProviders,
      ref: function ref(element) {
        return _this2.intent = element;
      },
      intent: name,
      customAdditionalParams: customAdditionalParams,
      additionalParams: this.state.urlParams,
      additionalPath: this.state.urlPath,
      onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
        return _this2.handleMessageReceived(type, payload, resolve, reject, providerId);
      }
    }) : null;
    return renderComponent;
  };
  return ProviderModalOOI;
}(_react.Component);